import {PLP_ID} from "../../config/constants"

export const getPortalEntrypoint = (): HTMLElement | null => {
    return typeof document !== "undefined" ? document.getElementById(PLP_ID) : null
}
